/** @format */

import React from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

const LicenseModal = ({ openModal, isOpen, closeModal, LicImageAddDriver }) => {
  const licImage = assetUrl("../../assets/images/licImage.png");
  const css = assetUrl("../../styles/licenseModal.css");

  return (
    <div>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
      </Helmet>
      {isOpen && (
        <div
          className={`modalImage margin-top-10 ${
            isOpen ? "openImage" : ""
          } ${LicImageAddDriver}`}
        >
          <div className="modal-content2">
            <span className="close2" onClick={closeModal}>
              &times;
            </span>
            <img
              className="licImageStyle"
              height="auto"
              width="100%"
              src={licImage}
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LicenseModal;
